<template>
    <Popover class="relative">
        <PopoverButton
            class="focus:outline-hidden"
            data-spec-class="feedback-button__trigger"
        >
            <div
                class="-mb-1.5 rounded-t-md bg-blue-800 px-4 py-2 whitespace-nowrap text-white transition duration-300 ease-out hover:-translate-y-1.5 ui-open:transform ui-open:opacity-0"
            >
                {{ t('actions.feedback') }}
            </div>
        </PopoverButton>

        <PopoverPanel
            v-slot="{ close }"
            class="absolute bottom-20 z-10 w-96 -translate-x-1/2 rotate-90"
            data-spec-class="feedback-button__panel"
        >
            <div class="rounded-xl border border-divider bg-surface--elevated p-6 shadow-lg">
                <div class="absolute top-0 right-0 mr-3 hidden pt-3 sm:block">
                    <BaseButtonClose
                        data-spec-class="feedback-button__close"
                        @click="onClose(close)"
                    />
                </div>
                <div>
                    <div class="mb-3 text-center font-semibold text-primary">
                        {{ t('dialogs.feedback.title') }}
                    </div>
                    <UserFeedbackForm @submit="onClose(close)" />
                </div>
            </div>
        </PopoverPanel>
    </Popover>
</template>

<script setup lang="ts">
import { ref } from 'vue';

import { Popover, PopoverButton, PopoverPanel } from '@headlessui/vue';
import { useI18n } from 'vue-i18n';
import BaseButtonClose from './BaseButtonClose.vue';
import UserFeedbackForm from '@/modules/your/components/UserFeedbackForm.vue';

const { t } = useI18n();

const isOpen = ref(false);

const onClose = (close) => {
    isOpen.value = false;
    close();
};
</script>
